import React from 'react';

interface PaginationProps {
  count: number;
  page: number;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  color?: 'primary' | 'secondary' | 'standard';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  count,
  page,
  onChange,
  color = 'primary',
  size = 'medium',
  className = '',
}) => {
  const handlePageChange = (newPage: number) => {
    const syntheticEvent = {
      target: { value: newPage },
    } as unknown as React.ChangeEvent<unknown>;
    onChange(syntheticEvent, newPage);
  };

  const sizeClasses = {
    small: 'px-2 py-1 text-sm',
    medium: 'px-3 py-2 text-base',
    large: 'px-4 py-3 text-lg',
  };

  const colorClasses = {
    primary: 'bg-blue-600 hover:bg-blue-700 text-white',
    secondary: 'bg-gray-600 hover:bg-gray-700 text-white',
    standard: 'bg-gray-200 hover:bg-gray-300 text-gray-900 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100',
  };

  return (
    <div className={`flex items-center justify-center space-x-2 ${className}`}>
      <button
        onClick={() => handlePageChange(page - 1)}
        disabled={page <= 1}
        className={`${sizeClasses[size]} rounded border ${page <= 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100 dark:hover:bg-gray-800'} border-gray-300 dark:border-gray-600`}
      >
        Previous
      </button>
      <span className={`${sizeClasses[size]} text-gray-700 dark:text-gray-300`}>
        Page {page} of {count}
      </span>
      <button
        onClick={() => handlePageChange(page + 1)}
        disabled={page >= count}
        className={`${sizeClasses[size]} rounded border ${page >= count ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100 dark:hover:bg-gray-800'} border-gray-300 dark:border-gray-600`}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;

